import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import LogOutWarning from './LogOutWarning';

const DEFAULT_IDLE = 28800 * 1000; // 8 hours
const DEFAULT_LOGOUT = 30000; // 30 seconds
const STAY_CLICKED = 'alli-frontend-auth-stay-clicked';
const IDLE_NAME = 'alli-frontend-auth';

export default function IdleTracker({
    logout,
    idleTimeout = DEFAULT_IDLE,
    logoutTimeout = DEFAULT_LOGOUT,
}) {
    const [showLogout, setShowLogout] = useState(false);
    const onPrompt = useCallback(() => {
        setShowLogout(true);
    }, [setShowLogout]);

    const onMessage = useCallback(
        message => {
            if (message === STAY_CLICKED) {
                setShowLogout(false);
            }
        },
        [setShowLogout],
    );

    const { start, message } = useIdleTimer({
        crossTab: true,
        syncTimers: true,
        name: IDLE_NAME,
        timeout: idleTimeout, // show the prompt after this many millis
        promptTimeout: logoutTimeout, // call onIdle after the prompt fires
        // on idle is called _after_ the idle timeout + prop timeout happen
        // so we can be sure that we're logging out for real at the point
        // this is called.
        onIdle: logout,
        onPrompt,
        onMessage,
    });

    const onStay = useCallback(() => {
        message(STAY_CLICKED, true);
        start();
    }, [message, start]);

    const onLeave = useCallback(() => {
        logout();
    }, [logout]);

    return showLogout ? <LogOutWarning onStay={onStay} onLeave={onLeave} /> : null;
}
